module.exports = __webpack_public_path__ + "static/media/OnlineClasses.44487e21.gif";